export default __webpack_public_path__ + "static/media/divorce.ecba4d4d.png";